module.exports = __webpack_public_path__ + "img/id.ca8175c0.svg";